// extracted by css-extract-rspack-plugin
export default {"splitter":"splitter-1STPx","outline":"outline-SYyps"};